module.exports = __webpack_public_path__ + "static/media/html-css.16a96b2a.png";